var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCbNyLogoTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #231f20;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.35,425.17l-28.57,35.2h-72.18c-49.84,0-86.58-30.08-86.58-69.79s36.74-67.13,86.58-67.13h100.75l-28.57,35.61h-72.18c-24.06,0-42.11,13.71-42.11,33.36s17.83,32.74,42.11,32.74h100.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.58,420.46c0,22.72-13.1,39.91-58.43,39.91h-126.32v-83.29h127.18c6.44,0,12.46-2.25,12.46-9.21s-6.23-8.8-12.46-8.8h-127.18l30.08-35.61h95.17c34.37,0,56.5,12.69,56.5,37.86,0,16.17-9.67,25.17-19.55,28.65,12.46,3.48,22.56,14.12,22.56,30.49ZM360.51,406.34v18.83h81.85c9.67,0,13.75-3.27,13.75-9.62,0-5.93-4.08-9.21-13.75-9.21h-81.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbNyLogoTemp);
export default __webpack_public_path__ + "static/media/cb_ny_logo_temp.a299342a344da3be50b56b971b6ca00b.svg";
export { ForwardRef as ReactComponent };